import React, { Component } from "react";
import { Card, CardBody, Label, Row } from "reactstrap";
import Form from "./form";
import TablesData from "../../../Components/Table";
import { Popup } from "semantic-ui-react";

class MainInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataShipmet: props.data,
      key: props.key,
    };
  }

  componentDidMount = () => {
    this.buildDetail();
  };

  componentWillReceiveProps = (NextProps) => {
    this.setState(
      {
        dataShipmet: NextProps.data,
      },
      () => {
        this.buildDetail();
      }
    );
  };

  buildDetail = () => {
    let { dataShipmet } = this.state
    let formDetail = Form.Detail.map((e, key) => {
      if (e.type === "Tittle") {
        return (
          <Row>
            <div className="col-md-12" key={key}>
              <Label tag="h4" style={{ color: "black" }}>
                {e.label}
              </Label>
              <br></br>
            </div>
          </Row>
        );
      } else if (e.type === "Header") {
        return (
          <Row>
            <div className="col-md-12" key={key} style={{ color: "black" }}>
              <b>{e.label}</b>
            </div>
          </Row>
        );
      } else if (e.type === "Text") {
        return (
          <>
            <Row>
              <div className="col-md-4" key={key}>
                <Label style={{ fontWeight: "bold", fontSize: "12px" }}>
                  {dataShipmet.TransportMode === "InLand" && e.label === "ETD:"
                    ? ""
                    : dataShipmet.TransportMode === "InLand" && e.label === "ETA:"
                      ? ""
                      : dataShipmet.TransportMode === "InLand" && e.label === "ATD:"
                        ? e.labelTe
                        : dataShipmet.TransportMode === "InLand" && e.label === "ATA:"
                          ? e.labelTe
                          : dataShipmet.TransportMode === "InLand" && e.label === "Project:"
                            ? ""
                            : dataShipmet.TransportMode === "InLand" && e.label === "MBL/AWB:"
                              ? ""
                              : dataShipmet.TransportMode === "InLand" && e.label === "Carrier:"
                                ? ""
                                : dataShipmet.TransportMode === "InLand" && e.label === "Agent:"
                                  ? ""
                                  : dataShipmet.TransportMode === "InLand" && e.label === "Co-Loader:"
                                    ? ""
                                    : dataShipmet.TransportMode === "InLand" && e.label === "Vessel:"
                                      ? ""
                                      : dataShipmet.TransportMode === "InLand" && e.label === "Voyage/Flight No:"
                                        ? ""
                                        : dataShipmet.TransportMode === "InLand" && e.label === "3PL Reference:"
                                          ? ""
                                          : dataShipmet.TransportMode === "FCL" && e.label === "Co-Loader:"
                                            ? ""
                                            : e.label}
                </Label>
              </div>
              <div className="col-md-8">
                <Label style={{ fontSize: "12px" }}>
                  {dataShipmet.TransportMode === "InLand" && e.label === "ETD:"
                    ? ""
                    : dataShipmet.TransportMode === "InLand" && e.label === "ETA:"
                      ? ""
                      : dataShipmet.TransportMode === "InLand" && e.label === "Project:"
                        ? ""
                        : dataShipmet.TransportMode === "InLand" && e.label === "MBL/AWB:"
                          ? ""
                          : dataShipmet.TransportMode === "InLand" && e.label === "Carrier:"
                            ? ""
                            : dataShipmet.TransportMode === "InLand" && e.label === "Agent:"
                              ? ""
                              : dataShipmet.TransportMode === "InLand" && e.label === "Co-Loader:"
                                ? ""
                                : dataShipmet.TransportMode === "InLand" && e.label === "Vessel:"
                                  ? ""
                                  : dataShipmet.TransportMode === "InLand" && e.label === "Voyage/Flight No:"
                                    ? ""
                                    : dataShipmet.TransportMode === "InLand" && e.label === "3PL Reference:"
                                      ? ""
                                      : dataShipmet.TransportMode === "FCL" && e.label === "Co-Loader:"
                                        ? ""
                                        : this.state.dataShipmet[dataShipmet.TransportMode === "InLand" && e.id === "ATD" ? e.idTe : e.id]
                                          ? this.state.dataShipmet[dataShipmet.TransportMode === "InLand" && e.id === "ATD" ? e.idTe : e.id]
                                          : "---"}
                  {/* {e.label === "Co-Loader:" &&
                    this.state.dataShipmet.TransportMode !== "LCL"
                    ? ""
                    : this.state.dataShipmet[e.id]
                      ? this.state.dataShipmet[e.id]
                      : "---"} */}
                  {/* {this.state.dataShipmet[e.id] ? this.state.dataShipmet[e.id] : "---"} */}
                </Label>
              </div>
            </Row>
          </>
        );
      } else if (e.type === "info") {
        return (
          <>
            <Row>
              <div className="col-md-4" key={key}>
                <Label style={{ fontWeight: "bold", fontSize: "12px" }}>
                  {dataShipmet.TransportMode === "InLand" && e.label === "ETD:"
                    ? ""
                    : dataShipmet.TransportMode === "InLand" && e.label === "ETA:"
                      ? ""
                      : dataShipmet.TransportMode === "InLand" && e.label === "ATD:"
                        ? e.labelTe
                        : dataShipmet.TransportMode === "InLand" && e.label === "ATA:"
                          ? e.labelTe
                          : dataShipmet.TransportMode === "InLand" && e.label === "Project:"
                            ? ""
                            : dataShipmet.TransportMode === "InLand" && e.label === "MBL/AWB:"
                              ? ""
                              : dataShipmet.TransportMode === "InLand" && e.label === "Carrier:"
                                ? ""
                                : dataShipmet.TransportMode === "InLand" && e.label === "Agent:"
                                  ? ""
                                  : dataShipmet.TransportMode === "InLand" && e.label === "Co-Loader:"
                                    ? ""
                                    : dataShipmet.TransportMode === "InLand" && e.label === "Vessel:"
                                      ? ""
                                      : dataShipmet.TransportMode === "InLand" && e.label === "Voyage/Flight No:"
                                        ? ""
                                        : dataShipmet.TransportMode === "InLand" && e.label === "3PL Reference:"
                                          ? ""
                                          : dataShipmet.TransportMode === "FCL" && e.label === "Co-Loader:"
                                            ? ""
                                            : e.label}

                  <Popup
                    trigger={<i className="fas fa-info-circle ml-1 info-circle"></i>}
                    content={
                      <TablesData
                        columns={e.columns}
                        data={Object.keys(dataShipmet).length !== 0 ? dataShipmet.historico[e.EventId] ? dataShipmet.historico[e.EventId] : [] : []}
                        options={{
                          large: false,
                          downloads: {
                            pdf: false,
                            xlsx: false
                          },
                          pagination: false,
                          search: false,
                        }} />
                    }
                    basic
                    // style={style}
                    // open={true}
                    className="table-tooltip"
                    position='right center'
                  />
                </Label>
              </div>
              <div className="col-md-8">
                <Label style={{ fontSize: "12px" }}>
                  {dataShipmet.TransportMode === "InLand" && e.label === "ETD:"
                    ? ""
                    : dataShipmet.TransportMode === "InLand" && e.label === "ETA:"
                      ? ""
                      : dataShipmet.TransportMode === "InLand" && e.label === "Project:"
                        ? ""
                        : dataShipmet.TransportMode === "InLand" && e.label === "MBL/AWB:"
                          ? ""
                          : dataShipmet.TransportMode === "InLand" && e.label === "Carrier:"
                            ? ""
                            : dataShipmet.TransportMode === "InLand" && e.label === "Agent:"
                              ? ""
                              : dataShipmet.TransportMode === "InLand" && e.label === "Co-Loader:"
                                ? ""
                                : dataShipmet.TransportMode === "InLand" && e.label === "Vessel:"
                                  ? ""
                                  : dataShipmet.TransportMode === "InLand" && e.label === "Voyage/Flight No:"
                                    ? ""
                                    : dataShipmet.TransportMode === "InLand" && e.label === "3PL Reference:"
                                      ? ""
                                      : dataShipmet.TransportMode === "FCL" && e.label === "Co-Loader:"
                                        ? ""
                                        : this.state.dataShipmet[dataShipmet.TransportMode === "InLand" && e.id === "ATD" ? e.idTe : e.id]
                                          ? this.state.dataShipmet[dataShipmet.TransportMode === "InLand" && e.id === "ATD" ? e.idTe : e.id]
                                          : "---"}
                </Label>
              </div>
            </Row >
          </>
        );
      }
      else return <hr></hr>;
    });
    this.setState({
      formDetail,
    });
  };

  render() {
    return (
      <Card className="myCard">
        <CardBody>{this.state.formDetail}</CardBody>
      </Card>
    );
  }
}

export default MainInfo;
